import { combineReducers } from "redux";
import snackBarReducer from '../app/modules/Snackbar/snackbar.reducer';
import * as activity from '../app/modules/activity/_redux';
import * as auth from "../app/modules/Auth/_redux";
import * as supportTicket from '../app/modules/support_ticket/_redux';
import * as profile from '../app/modules/profile_settings/_redux';
import etheriumReducer from '../app/modules/smartContract/etheriumReducer';
import stakeReducer from '../app/modules/smartContract/stakeReducer';
import notificationReducer from '../app/modules/notifications/_redux/notificattion.reducer';

export const rootReducer = combineReducers({
  auth: auth.reducer,
  supportTicket: supportTicket.reducer,
  snackBar: snackBarReducer,
  activity: activity.reducer,
  profile: profile.reducer,
  etherium: etheriumReducer,
  stake: stakeReducer,
  notification: notificationReducer,
});